import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/guru-personalinfo";
var post = "/guru-personalinfo";
export const actGetDataGuruPersonalInfo = (id = "", filter = "teacher") => {
  return (dispatch) => {
    let config = CONFIG_({
      url: get + "/" + id + "?filter=" + filter,
      method: "GET",
    });
    dispatch({ type: "LOADING_GURUPERSONALINFO_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 202 || data.length >= 0) {
          return dispatch({
            type: "SUCCESS_GURUPERSONALINFO_GURU",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataGuruPersonalInfo = (params) => {
  return (dispatch) => {
    const { guru } = params;
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_GURUPERSONALINFO_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_PERSONALINFOGURU", open: false })
          );
          return dispatch(actGetDataGuruPersonalInfo(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataGuruPersonalInfo = (params) => {
  return (dispatch) => {
    const { id, guru } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_GURUPERSONALINFO_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative has been update");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_PERSONALINFOGURU", open: false })
          );
          return dispatch(actGetDataGuruPersonalInfo(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataGuruPersonalInfo = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_GURUPERSONALINFO_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_GURUPERSONALINFO_DETAIL",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataGuruPersonalInfo = (params) => {
  return (dispatch) => {
    const { id, guru } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_GURUPERSONALINFO_GURU" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Relative has been deleted");
          return dispatch(actGetDataGuruPersonalInfo(guru));
        }
        warningnotify(response.message);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_GURUPERSONALINFO_GURU",
          message: "Network error..",
        });
      });
  };
};
